import "./buttons.scss";

import ICON from "../icons/moreIconVertical.svg";
import { MouseEvent } from "react";

export const MoreButton = (props: {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  id?: string;
}): JSX.Element => {
  return (
    <button
      id={props.id}
      className="rg-button more"
      title="Show more options"
      onClick={props.onClick}
    >
      <img src={ICON} alt="" />
    </button>
  );
};
